import Alodokter from "../utils/Alodokter";
import General from "../utils/General";
import { _checkInitialModulProgress, _checkModulProgress, _checkPassedEcourse } from "../utils/ecourse";

export default class EcourseAnalytics {
        
    static viewItemList(data, isImpression) {
        const itemData = data.map((item) => {
            return {
                item_id: item.id,
                item_name: item.title,
                item_category: "ecourse",
                item_category2: item.is_paid ? "paid" : "free",
                price: item.payment_info ? General.getNumber(item.payment_info.normal_price) : 0,
                index: item.index + 1
            };
        });

        Alodokter.sendEventGA4({
            ecommerce: {
                items: itemData,
                item_list_name: isImpression ? "ecourse_visible" : "ecourse",
            },
            event: "view_item_list",
        });
    }

    static selectItem(data) {
        Alodokter.sendEventGA4({
            ecommerce: {
                items: [
                    {
                    item_id: data.ecourse.id,
                    item_name: data.ecourse.title,
                    price: data.ecourse.is_paid ? General.getNumber(data.ecourse.payment_info.normal_price) : 0,
                    item_category: "ecourse",
                    item_category2: data.ecourse.is_paid ? "paid" : "free"
                    }
                ],
            },
            registration_status: data.is_registered,
            trigger: data.is_from_card ? "card_area" : "cta",
            event: "select_item",
        });
    }

    static viewItem(data) {
        Alodokter.sendEventGA4({
            ecommerce: {
                items: [
                    {
                        item_id: data.ecourse.id,
                        item_name: data.ecourse.title,
                        price: data.ecourse.is_paid ? General.getNumber(data.ecourse.payment_info.normal_price) : 0,
                        item_category: "ecourse",
                        item_category2: data.ecourse.is_paid ? "paid" : "free",
                    }
                ],
            },
            registration_status: data.is_registered,
            event: "view_item",
        })
    }

    static addToCart(data) {
        Alodokter.sendEventGA4({
            ecommerce: {
                items: [
                    {
                    item_id: data.id,
                    item_name: data.title,
                    item_category: "ecourse",
                    item_category2: data.is_paid ? "paid" : "free",
                    price: data.payment_info?.normal_price ? General.getNumber(data.payment_info.normal_price) : 0,
                    }
                ],
                currency: "IDR",
                value: data.payment_info?.normal_price ? General.getNumber(data.payment_info.normal_price) : 0,
            },
            event: "add_to_cart",
        });
    }

    static beginLearn(data) {
        let beginType;
        if (_checkPassedEcourse(data.user_status)) {
            beginType = "finished";
        } else if (_checkModulProgress(data.user_status)) {
            beginType = "first";
        } else if (_checkInitialModulProgress(data.user_status)) {
            beginType = "continue";
        }
        const tracker = {
            item_id: data.id,
            item_name: data.title,
            item_category: "ecourse",
            begin_type: beginType,
            event: "begin_learn",
        };
        Alodokter.sendEventGA4(tracker);
    }

    static startTest(data,accessibility){
        const tracker = {
            parent_id: accessibility.meta_data.ecourse_id,
            item_id: data.id,
            item_name: data.title,
            skp_type: 'module',
            index:data.module.order,
            event: "start_test"
        };
        Alodokter.sendEventGA4(tracker);
    }

    static finishTest(skpId,data){
        const test_result = data.status == 'pass' ? 'passed' : 'failed'
        const tracker = {
            item_id: skpId,
            parent_id: data.ecourse_id,
            item_name: data.skp.title,
            skp_type: 'module',
            index: data.skp.module_order,
            test_result: test_result,
            event: "finish_test"
        };
        Alodokter.sendEventGA4(tracker);
    }

    static viewSkp(data,accessibility){
        const progress_status = data.status == 0 ? 'not_started' : data.status == 1 ? 'failed' : 'passed'
        const tracker = {
            item_id: data.id,
            parent_id: accessibility.meta_data.ecourse_id,
            item_name: data.title,
            skp_type: 'module',
            index:data.module.order,
            progress_status: progress_status,
            event: "view_skp",
        };
        Alodokter.sendEventGA4(tracker);
    }

    static selectModule(data,ecourseId,source,index,progressStatus) {
        const tracker = {
            item_id: data.id,
            parent_id: ecourseId,
            item_name: data.title,
            element:source,
            item_category: "module",
            index:index,
            progress_status: progressStatus,
            event: "select_module",
        };
        Alodokter.sendEventGA4(tracker);
    }

    static selectMyEcourse(data, isFromCard) {
        const tracker = {
            item_id: data.id,
            item_name: data.title,
            item_category: "ecourse",
            item_category2: data.is_paid ? "paid" : "free",
            registration_status: true,
            trigger: isFromCard ? "card_area" : "cta",
            entry_point: "ecourse_anda",
            event: "view_history",
        };
        Alodokter.sendEventGA4(tracker);
    }

    static selectMyTransactionEcourse(data, isFromCard) {
        const tracker = {
            item_id: data.id,
            transaction_id: data.transaction_id,
            item_name: data.title,
            item_category: "ecourse",
            item_category2: data.transaction_id ? "paid" : "free",
            registration_status: true,
            transaction_status: data.payment_status,
            trigger: isFromCard ? "card_area" : "cta",
            entry_point: "ecourse_transaction",
            event: "view_history",
        };
        Alodokter.sendEventGA4(tracker);
    }
}
